var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagPablo = function SvgShoppingBagPablo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.934 14.705c0 1.552.804 2.348 2.372 2.348h9.416c1.408 0 2.212-.804 2.212-2.348v-8.42c0-1.551-.804-2.347-2.373-2.347h-1.439C11.082 2.362 9.755.946 7.93.946c-1.818 0-3.145 1.416-3.185 2.992h-1.44c-1.567 0-2.371.788-2.371 2.348zM5.742 3.938c.032-1.078.893-2.043 2.188-2.043 1.294 0 2.163.965 2.195 2.043zm-3.811 10.71V6.335c0-.925.49-1.407 1.39-1.407h9.216c.893 0 1.4.482 1.4 1.407v8.315c0 .933-.507 1.407-1.239 1.407H3.322c-.9 0-1.391-.475-1.391-1.407"
  })));
};
export default SvgShoppingBagPablo;